// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__dIp-0","icon":"style_icon__uULlt","text":"style_text__RKN-X","title":"style_title__2lKyw"};